import { LitElement, css, html } from 'lit'

export class DzCatcher extends LitElement {
    static get properties() {
        return {
            catch: { type: String },
            itemUpdated: { type: String }
        }
    }

    render() {
        return html`<slot id="main-slot" @slotchange="${this.slotChanged}"></slot>`
    }

    slotChanged() {
       if (this.innerHTML == this.catch) {
            let slot = this.renderRoot.getElementById("main-slot")
            this.innerHTML = this.itemUpdated
       }
    }

}

window.customElements.define('dz-catcher', DzCatcher)